// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditGender {
    width: 100%;
}

.editGenderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.editGenderCard {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 22px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.editGenderLabel {
    color: #839696;
    font-family: "Inter", sans-serif;
    font-size: 13.5px;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.genderDropdownContainer {
    position: relative;
    width: 100%;
}

.genderSelect {
    width: 100%;
    height: 52px;
    background-color: #142424;
    border: 1px solid #233737;
    border-radius: 12px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-sizing: border-box;
    transition: all 0.2s ease;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.genderSelect:hover {
    border-color: #4DCBCA;
}

.genderPlaceholder {
    color: #7A7A7A;
    font-family: "Inter", sans-serif;
    font-size: 15px;
}

.genderInputText {
    color: #FFFFFF;
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.genderArrowIcon {
    color: #5AAF9A;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
}

.genderSelect:hover .genderArrowIcon {
    color: #4DCBCA;
}

.genderDropdownMenu {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);
    list-style: none;
    padding: 8px;
    margin: 0;
    z-index: 1000;
    max-height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: #5AAF9A #0E1B1B;
    box-sizing: border-box;
}

.genderDropdownMenu li {
    padding: 10px 14px;
    color: #FFFFFF;
    cursor: pointer;
    border-radius: 8px;
    font-family: "Inter", sans-serif;
    font-size: 14.5px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.genderDropdownMenu li:hover {
    background-color: #142424;
    color: #4DCBCA;
}

.editGenderSubmitBtnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin-top: 10px;
}

.editGenderSubmitBtn {
    width: 100%;
    height: 48px;
    background-color: #5AAF9A;
    color: #0E1B1B;
    border: none;
    border-radius: 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);
}

.editGenderSubmitBtn:hover:not(:disabled) {
    background-color: #4DCBCA;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);
}

.editGenderSubmitBtn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

@media (max-width: 768px) {
    .editGenderCard,
    .editGenderSubmitBtnContainer {
        width: 95%;
        padding: 18px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/EditGender/EditGender.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;;QAEI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditGender {\n    width: 100%;\n}\n\n.editGenderContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.editGenderCard {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 22px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n.editGenderLabel {\n    color: #839696;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13.5px;\n    font-weight: 500;\n    letter-spacing: 0.2px;\n}\n\n.genderDropdownContainer {\n    position: relative;\n    width: 100%;\n}\n\n.genderSelect {\n    width: 100%;\n    height: 52px;\n    background-color: #142424;\n    border: 1px solid #233737;\n    border-radius: 12px;\n    padding: 0 16px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.genderSelect:hover {\n    border-color: #4DCBCA;\n}\n\n.genderPlaceholder {\n    color: #7A7A7A;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n}\n\n.genderInputText {\n    color: #FFFFFF;\n    font-family: \"Inter\", sans-serif;\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.genderArrowIcon {\n    color: #5AAF9A;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s ease;\n}\n\n.genderSelect:hover .genderArrowIcon {\n    color: #4DCBCA;\n}\n\n.genderDropdownMenu {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    width: 100%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 12px;\n    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.7);\n    list-style: none;\n    padding: 8px;\n    margin: 0;\n    z-index: 1000;\n    max-height: 240px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: #5AAF9A #0E1B1B;\n    box-sizing: border-box;\n}\n\n.genderDropdownMenu li {\n    padding: 10px 14px;\n    color: #FFFFFF;\n    cursor: pointer;\n    border-radius: 8px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14.5px;\n    font-weight: 500;\n    transition: all 0.15s ease;\n}\n\n.genderDropdownMenu li:hover {\n    background-color: #142424;\n    color: #4DCBCA;\n}\n\n.editGenderSubmitBtnContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin-top: 10px;\n}\n\n.editGenderSubmitBtn {\n    width: 100%;\n    height: 48px;\n    background-color: #5AAF9A;\n    color: #0E1B1B;\n    border: none;\n    border-radius: 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 14px rgba(90, 175, 154, 0.25);\n}\n\n.editGenderSubmitBtn:hover:not(:disabled) {\n    background-color: #4DCBCA;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(77, 203, 202, 0.35);\n}\n\n.editGenderSubmitBtn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n    .editGenderCard,\n    .editGenderSubmitBtnContainer {\n        width: 95%;\n        padding: 18px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
